import { action } from 'nanostores'

import type { CMSLoggedInSettings } from '@/types/sanity'

import { $loggedInSettings } from './stores'

export const setLoggedInSettings = action(
  $loggedInSettings,
  'setLoggedInSettings',
  (store, loggedInSettings: CMSLoggedInSettings) => {
    store.set(loggedInSettings)
    return loggedInSettings
  },
)
